// import { Uid } from "./Uid";
import { User } from "./User";

export type NotificationType = 'Text' | 'Voice' | 'Images' | 'Docs' | 'Emoticon' | 'RoomAdded' | 'Info' | 'CallStart' | 'VideoRecording' | 'Emoji';

//notification
export class Notification {
  static COL = 'notifications';
  id: string;

  created: Date = new Date();
  isNew = true;
  isMentioned?: boolean = false;
  subtitle?: string;

  constructor(
    public type: NotificationType,
    public toUserId: string,
    public roomId: string | null,
    public roomName: string | null,
    public messageId: string | null,
    public parentMessageId: string | null,
    public replyToMessageId: string | null,
    public fromUser: User | null) {
    this.id = uuid();
  }
}

function uuid(): string {
  //uuidv4
  return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}